/**
 * @generated SignedSource<<59f2b7229f106a8098c2fc3ceda9e41b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPostiesArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleUtilsGetArticleTypeArticle" | "genericPostiesArticleContent">;
  readonly " $fragmentType": "hooksPostiesArticleArticle";
};
export type hooksPostiesArticleArticle$key = {
  readonly " $data"?: hooksPostiesArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPostiesArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPostiesArticleArticle",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "articleUtilsGetArticleTypeArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "customContents",
          "variableName": "customContents"
        }
      ],
      "kind": "FragmentSpread",
      "name": "genericPostiesArticleContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a9bc78c74f060cbc23d287dd7fcf4415";

export default node;
